import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import PrivacyLinks from '../../policyLinks';

export const PrivacyLinksWrapper: FC = () => {
  const visibleLegalLink = useSelector(
    (state: RootState) => state.settings.visibleLegalLink
  );

  return (
    visibleLegalLink && (
      <div className='layout-app__footer'>
        <PrivacyLinks />
      </div>
    )
  );
};
